import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";

// components
import { Loader, NewNavbar, Sidebar, Section } from "src/components";

import { SearchDestination, TopSection, MainSection } from "./components";

// network
import { fetchSearchEvents } from "./utils/network";
import { search_event_list } from "./data";

import styles from "./SearchContent.module.scss";
const cx = classNames.bind(styles);
let AllEvents = [];

const SearchContent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [events, setEvents] = useState([]);
  const [currentEvents, setCurrentEvents] = useState([]);

  const [tabs, setTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    fetchSearchEvents()
      .then((res) => {
        if (res.data.Status) {
          const result = res.data.Results;

          const _tabs = result.map((item, i) => ({
            name: item.Tabs,
            index: i,
          }));
          setTabs(_tabs);
          setCurrentTab(_tabs[0]);

          const _list = result.map((item) => item.Events);
          _list.forEach((curr) => {
            AllEvents = [...AllEvents, ...curr];
          });

          setEvents(_list);
          setCurrentEvents(_list[0]);
        } else {
          console.log(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const result = search_event_list;

  //   const _tabs = result.map((item, i) => ({
  //     name: item.Tabs,
  //     index: i,
  //   }));
  //   setTabs(_tabs);
  //   setCurrentTab(_tabs[0]);

  //   const _list = result.map((item) => item.Events);
  //   _list.forEach((curr) => {
  //     AllEvents = [...AllEvents, ...curr];
  //   });

  //   setEvents(_list);
  //   setCurrentEvents(_list[0]);
  //   setIsLoading(false);
  // }, []);

  const handleTabChange = (_tab) => {
    setCurrentTab(_tab);
    setCurrentEvents(events[_tab.index]);
  };

  const handleInputChange = (_value) => {
    const value = _value.toLowerCase();

    const filter = AllEvents.filter((event) =>
      event.EventName.toLowerCase().includes(value)
    );

    setCurrentEvents(filter);
    setCurrentTab(null);
  };

  return (
    <div>
      <NewNavbar />
      <Section>
        {!isLoading ? (
          <div className={cx("search-content-root")}>
            <SearchDestination />
            <TopSection handleInputChange={handleInputChange} />
            <MainSection
              tabs={tabs}
              currentEvents={currentEvents}
              currentTab={currentTab}
              handleTabChange={handleTabChange}
            />
          </div>
        ) : (
          <Loader />
        )}
      </Section>
    </div>
  );
};

export default SearchContent;
